import {validateName} from '@/validate';
import {FormValues} from '@/login/forgot_password/form/types';

export const validate = ({username}: FormValues) => {
  return {username: validateName(username)};
};
